'use strict';

function SalaryQuestionnaireController(salaryService, errorHandlerService, $location, $interpolate, $modal, $rootScope) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.$onDestroy = $onDestroy;
  vm.stepChange = stepChange;

  vm.stepChangeOk = stepChangeOk;
  vm.stepChangeFailed = stepChangeFailed;

  vm.hasPerformanceReviewQuestion = hasPerformanceReviewQuestion;
  vm.showPerformanceReviewQuestion = showPerformanceReviewQuestion;
  vm.hasRole = hasRole;
  vm.updateCurrentAnswer = updateCurrentAnswer;

  function $onInit() {
    vm.max = vm.data.max;
    vm.current = vm.data.current || 0;
    vm.answers = vm.data.answers || [];
    vm.question = vm.data.question;
    vm.choices = vm.data.question.choices;
    vm.round = vm.data.round;
    vm.user = vm.data.user || {};

    vm.choice = vm.data.question.answer.choice;
    vm.comment = vm.data.question.answer.comment;
    if (vm.data.user.id !== vm.me.id) {
      $rootScope.$broadcast('$setManagerSCope', true);
    } else {
      $rootScope.$broadcast('$setManagerSCope', false);
    }

    vm.didStepChange = false;
  }

  function $onDestroy() {
    if (vm.didStepChange === false) {
      updateCurrentAnswer();
    }
  }

  function updateCurrentAnswer() {
    return salaryService.update
      .answer(vm.data.question.answer.id, vm.choice, vm.comment);
  }

  function stepChange(to) {
    return updateCurrentAnswer()
      .then(vm.stepChangeOk(to))
      .catch(vm.stepChangeFailed(to));
  }

  function stepChangeOk(to) {
    vm.didStepChange = true;
    return function okResponse(response) {
      $location.path($interpolate('/salary/questionnaire/{{token}}/{{step}}')({token: vm.data.token, step: to}));
      return response;
    };
  }

  function stepChangeFailed(to) {
    return function failedResponse(error) {
      vm.didStepChange = false;
      var modal = $modal({template: require('./salary-questionnaire.modal.html'), show: true, locals: {to: to}});
      errorHandlerService.updateModalError(modal, error);
      return error;
    };
  }

  function hasPerformanceReviewQuestion() {
    return vm.data.assessment ? vm.data.assessment.answer !== null : false;
  }

  function showPerformanceReviewQuestion() {
    var modal = $modal({template: require('./salary-questionnaire.performance-review-answer.modal.html'), show: true});
    modal.$scope.question = vm.data.assessment;
  }

  function hasRole(role) {
    return vm.me.groups
      .map(function (group) { return group.name; })
      .some(function (groupName) { return groupName === role; });
  }
}

module.exports = SalaryQuestionnaireController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-questionnaire/salary-questionnaire.controller.js
 ** module id = 216
 ** module chunks = 0
 **/